import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { UserContext } from "../../UserContext"; // ✅ Import User Context
import "../../index.css"; // Import the CSS file
import { Link } from "react-router-dom";



const Gratitude = () => {
  const { user } = useContext(UserContext); // ✅ Get user from context
  const category = "gratitude"; // Category for fetching videos
  const [videos, setVideos] = useState([]); // State to hold videos
  const [loading, setLoading] = useState(true); // State to handle loading

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const response = await axios.get(`https://wholeness-forward.onrender.com/api/video/videos/${category}`);
        if (Array.isArray(response.data)) {
          setVideos(response.data);
        }
      } catch (error) {
        console.error("Error fetching videos:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchVideos();
  }, []);

  // ✅ Handle Mark as Helpful
  const handleHelpfulClick = async (videoId) => {
    if (!user || !user.id) {
      alert("You must be logged in to mark as helpful.");
      return;
    }

    try {
      const response = await axios.post(`https://wholeness-forward.onrender.com/api/video/videos/toggleHelpful`, {
        videoId,
        userId: user.id,
      });

      // ✅ Update UI with new helpful count
      setVideos((prevVideos) =>
        prevVideos.map((video) =>
          video._id === videoId
            ? { ...video, helpfulCount: response.data.helpfulCount }
            : video
        )
      );
    } catch (error) {
      console.error("Error marking video as helpful:", error);
    }
  };

  return (
    <div className="page-container gratitude-page">
            <p class="disclaimer">
Disclaimer: As an Amazon Associate, I earn from qualifying purchases. If you make a purchase through the links here, 
I may earn a small commission at no extra cost to you. Thank you for your support.
</p>
<div className="micro-void"></div>
      <h1 className="page-title">Gratitude</h1>

      {/* Intro Section */}
      <img src="/images/wf-gratitude.webp" alt="Person practicing gratitude" className="page-image" />
      <p className="page-text">
        Gratitude is a powerful practice that has been shown to improve mental and physical health.
        Taking time to reflect on the positive aspects of life can help shift your mindset, reduce
        stress, and increase overall well-being. Whether practiced through journaling, meditation,
        or simply acknowledging the good in your life, gratitude has been linked to numerous
        psychological and physical benefits.
      </p>

      <h2 className="page-heading">Health Benefits</h2>
      <p className="page-text">Practicing gratitude regularly has many health benefits. These include:</p>
      <ul className="content-list">
        <li>Improved mental health and emotional resilience</li>
        <li>Reduced stress and anxiety</li>
        <li>Better sleep quality</li>
        <li>Increased happiness and positive emotions</li>
        <li>Stronger relationships</li>
        <li>Enhanced self-esteem</li>
      </ul>

      <hr className="section-divider" />
    

{/* Gratitude Habit Plan */}
<h2 className="page-heading">Create a Gratitude Habit</h2>
<p className="page-text">
  Developing a habit of gratitude can profoundly improve your mindset and overall health. Here's a simple framework to help you build a consistent gratitude practice:
</p>

<h3 className="subheading">Framework for Building a Gratitude Habit:</h3>
<ul className="content-list">
  <li>
    <strong>Start Small:</strong> Begin by acknowledging one thing you're grateful for each day. You can write it down in a journal, say it aloud, or reflect quietly.
  </li>
  <li>
    <strong>Be Consistent:</strong> Try to practice gratitude daily. You could start by dedicating 5 minutes in the morning or evening to reflect on the positive aspects of your life.
  </li>
  <li>
    <strong>Track Your Progress:</strong> Use a gratitude journal, app, or even a checklist to track your gratitude practice. Reflect on how you feel after doing it each day.
  </li>
</ul>

<h3 className="subheading">Examples of Gratitude Practices:</h3>
<ul className="content-list">
  <li>Write down three things you're grateful for each night before bed.</li>
  <li>Start your day by focusing on one thing you're thankful for.</li>
  <li>Practice gratitude during your commute—think of something you're thankful for while driving or riding the bus.</li>
  <li>Incorporate gratitude into your conversations—share what you're grateful for with loved ones during meals or gatherings.</li>
</ul>

<hr className="page-divider" />

      <h2 className="section-title">Curated Video Collection</h2>

      {/* If videos are still loading */}
      {loading ? (
        <p className="loading-message">Loading videos...</p>
      ) : (
        <div className="video-container">
          {videos.length > 0 ? (
            videos.map((video) => (
              <div key={video._id} className="video-card">
                <h3 className="video-title">{video.title}</h3>
                <p className="video-details">
                  <strong>Source:</strong> {video.source} <br />
                  <strong>Length:</strong> {video.length} <br />
                  {video.description}
                </p>
                <iframe
                  className="video-frame"
                  src={video.url}
                  title={video.title}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>

                {/* ✅ Helpful Button */}
                <div className="video-actions">
                  <button
                    onClick={() => handleHelpfulClick(video._id)}
                    disabled={video.usersWhoClickedHelpful?.includes(user?.id)}
                    className={`button ${video.usersWhoClickedHelpful?.includes(user?.id) ? "disabled" : ""}`}
                  >
                    {video.usersWhoClickedHelpful?.includes(user?.id)
                      ? `Helpful (${video.helpfulCount})`
                      : `Mark as Helpful (${video.helpfulCount || 0})`}
                  </button>
                </div>
              </div>
            ))
          ) : (
            <p className="no-videos-message">No videos found for this category.</p>
          )}
        </div>
      )}


      <hr className="section-divider" />
<h2 className="section-title">Curated Book Collection</h2>

<div className="book-card">
  <h3 className="book-title">Gratitude</h3>
  
  {/* Book Cover Image from Open Library */}
  <img 
    src="https://covers.openlibrary.org/b/id/8972714-M.jpg" // Open Library cover image URL
    alt="Gratitude by Oliver Sacks" 
    className="book-cover" 
  />
  
  {/* Attribution for Image Source */}
  <p className="image-source">Image Source: Open Library API</p>
  
  <div className="micro-void"></div>
  
  <p className="book-details">
    <strong>Author:</strong> Oliver Sacks <br />
    <div className="micro-void"></div>
    <strong>Overview:</strong> Gratitude is a series of personal essays by renowned neurologist Oliver Sacks. Written in the last months of his life, these essays reflect on his sense of thankfulness for his life experiences, the people he’s met, and the work he’s done. <br />
    <div className="barely-void"></div>
    <strong>Why It's Great:</strong> Sacks’ reflections on life and gratitude are profoundly moving. This book offers a unique perspective on how gratitude can transform even the hardest of circumstances, especially when faced with terminal illness.
  </p>
  
  <div className="micro-void"></div>
  
  <a
    href="https://amzn.to/4ii29mI" // Your actual Amazon affiliate link
    className="amazon-link"
    target="_blank"
    rel="noopener noreferrer"
  >
    Buy on Amazon-https://amzn.to/4ii29mI
  </a>
  
  {/* Affiliate Link Disclosure */}
  <p className="affiliate-link-disclaimer">As an Amazon Associate, I earn from qualifying purchases.</p>
  <div className="short-line"></div>
</div>

<div className="book-card">
  <h3 className="book-title">The Gifts of Imperfection</h3>
  
  {/* Book Cover Image from Open Library */}
  <img 
    src="https://covers.openlibrary.org/b/id/7414597-L.jpg" // Open Library cover image URL
    alt="The Gifts of Imperfection by Brené Brown" 
    className="book-cover"
    style={{ maxWidth: "150px", height: "auto" }} 
  />
  
  {/* Attribution for Image Source */}
  <p className="image-source">Image Source: Open Library API</p>
  
  <div className="micro-void"></div>
  
  <p className="book-details">
    <strong>Author:</strong> Brené Brown <br />
    <div className="micro-void"></div>
    <strong>Overview:</strong> In *The Gifts of Imperfection*, Brené Brown shares insights on how embracing vulnerability and imperfection can lead to greater courage, self-acceptance, and living a wholehearted life. <br />
    <div className="barely-void"></div>
    <strong>Why It's Great:</strong> This book is a transformative read for anyone struggling with perfectionism and shame. Brown offers a compassionate and practical guide for living authentically and cultivating a grateful mindset.
  </p>
  
  <div className="micro-void"></div>
  
  <a
    href="https://amzn.to/4iHFfFb" // Your actual Amazon affiliate link
    className="amazon-link"
    target="_blank"
    rel="noopener noreferrer"
  >
    Buy on Amazon-https://amzn.to/4iHFfFb
  </a>
  
  {/* Affiliate Link Disclosure */}
  <p className="affiliate-link-disclaimer">As an Amazon Associate, I earn from qualifying purchases.</p>
  <div className="short-line"></div>
</div>

<div className="book-card">
  <h3 className="book-title">Thanks! How the New Science of Gratitude Can Make You Happier</h3>
  
  {/* Book Cover Image from Open Library */}
  <img 
    src="https://covers.openlibrary.org/b/id/395056-M.jpg" // Open Library cover image URL
    alt="Thanks! How the New Science of Gratitude Can Make You Happier by Robert Emmons" 
    className="book-cover" 
  />
  
  {/* Attribution for Image Source */}
  <p className="image-source">Image Source: Open Library API</p>
  
  <div className="micro-void"></div>
  
  <p className="book-details">
    <strong>Author:</strong> Robert Emmons <br />
    <div className="micro-void"></div>
    <strong>Overview:</strong> In *Thanks!*, Robert Emmons, one of the world’s leading researchers on gratitude, examines how gratitude can improve our physical health, mental well-being, and relationships. He presents scientific studies to illustrate how cultivating gratitude can increase happiness. <br />
    <div className="barely-void"></div>
    <strong>Why It's Great:</strong> This is a must-read for anyone curious about the science behind gratitude. Emmons’ research-backed approach provides compelling evidence that practicing gratitude can change the way we experience the world.
  </p>
  
  <div className="micro-void"></div>
  
  <a
    href="https://amzn.to/4inXpMw" // Your actual Amazon affiliate link
    className="amazon-link"
    target="_blank"
    rel="noopener noreferrer"
  >
    Buy on Amazon-https://amzn.to/4inXpMw
  </a>
  
  {/* Affiliate Link Disclosure */}
  <p className="affiliate-link-disclaimer">As an Amazon Associate, I earn from qualifying purchases.</p>
  <div className="short-line"></div>
</div>

<div className="book-card">
  <h3 className="book-title">The Gratitude Diaries</h3>
  
  {/* Book Cover Image from Open Library */}
  <img 
    src="https://covers.openlibrary.org/b/id/11639005-M.jpg" // Open Library cover image URL
    alt="The Gratitude Diaries by Janice Kaplan" 
    className="book-cover" 
  />
  
  {/* Attribution for Image Source */}
  <p className="image-source">Image Source: Open Library API</p>
  
  <div className="micro-void"></div>
  
  <p className="book-details">
    <strong>Author:</strong> Janice Kaplan <br />
    <div className="micro-void"></div>
    <strong>Overview:</strong> *The Gratitude Diaries* chronicles Janice Kaplan’s year-long experiment in practicing gratitude every day. Through research and interviews, Kaplan shows how gratitude can change your mindset and improve your relationships, health, and happiness. <br />
    <div className="barely-void"></div>
    <strong>Why It's Great:</strong> This book offers a practical approach to gratitude, backed by real-life examples and actionable tips. It’s perfect for anyone looking to enhance their well-being through the simple yet profound practice of gratitude.
  </p>
  
  <div className="micro-void"></div>
  
  <a
    href="https://amzn.to/41Ex45F" // Your actual Amazon affiliate link
    className="amazon-link"
    target="_blank"
    rel="noopener noreferrer"
  >
    Buy on Amazon-https://amzn.to/41Ex45F
  </a>
  
  {/* Affiliate Link Disclosure */}
  <p className="affiliate-link-disclaimer">As an Amazon Associate, I earn from qualifying purchases.</p>
  <div className="short-line"></div>
</div>

<hr className="section-divider" />


      {/* Gratitude Apps */}
      <h2 className="page-heading">Popular Gratitude Apps</h2>
      <p className="page-text">
        If you're looking for guidance and reminders to help you practice gratitude, these apps can support your journey:
      </p>

      <h3 className="subheading">Grateful</h3>
      <p className="page-text">
        Grateful is a simple gratitude journaling app that allows you to document daily thoughts of gratitude. You can track your progress and create a personalized reflection habit.
      </p>

      <h3 className="subheading">Five Minute Journal</h3>
      <p className="page-text">
        The Five Minute Journal is a guided journaling app that prompts you to reflect on what you're grateful for in the morning and evening. This structured approach encourages consistency and mindfulness.
      </p>

      {/* Gratitude Tracker Call to Action */}
      <div className="gratitude-tracker-section">
        <h3 className="page-heading">Try Our Gratitude Tracker</h3>
        <p className="page-text">
          Ready to take your gratitude practice to the next level? Try out the Wholeness Forward Gratitude Tracker to easily track your daily moments of gratitude and watch your well-being grow.
        </p>
        <Link to="/gratitude" className="profile-link">Gratitude Tracker</Link>
      </div>

      <hr />

      <div className="forum-section">
        <h2 className="page-heading">Join the Gratitude Discussion</h2>
        <a href="/forum/Gratitude" className="forum-link">Go to Gratitude Forum</a>
      </div>
    </div>
  );
};

export default Gratitude;
